var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wholeContext"},[_c('app-sidebar'),_c('app-header-universal'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContext"},[_c('p',[_vm._v("권한 보기페이지")])])
}]

export { render, staticRenderFns }